import { FileUpload } from '../../../../../../File'
import { getApplicantCreditCheckUploadOptions } from '../../ApplicantCreditCheckBlock.utils'

function ApplicantCreditCheckActionUpload({
  children,
  isDisabled,
  isUpload,
  onFinishUpload,
  onStartUpload,
  onUploadErrors,
}) {
  return isUpload ? (
    <FileUpload
      disabled={isDisabled}
      options={getApplicantCreditCheckUploadOptions(isDisabled)}
      onFinishUpload={onFinishUpload}
      onStartUpload={onStartUpload}
      onUploadErrors={onUploadErrors}
    >
      {children}
    </FileUpload>
  ) : (
    children
  )
}

export default ApplicantCreditCheckActionUpload
